class Customer{
    constructor() {
        this.swiper_recommend = document.querySelector('.recommended') ? document.querySelectorAll('.recommended') : null;
        this.accordions = document.querySelector('.accordions') ? document.querySelectorAll('.accordions') : null;
        this.tabs = document.querySelector('.Product__Tabs') ? document.querySelectorAll('.Product__Tabs') : null;

        !this.tabs || this.tabs.forEach(el => this.sTabs(el));
        !this.accordions || this.accordions.forEach(el => this.Accordions(el));
        !this.swiper_recommend || this.swiper_recommend.forEach(el => this.SwiperGrup(el));

        
    }
    sTabs(el){
        !el.querySelector('.Collapsible') || el.querySelectorAll('.Collapsible').forEach(item => {
            item.querySelector('.Collapsible__Button').addEventListener('click', () => {
				item.querySelector('.Collapsible__Button').classList.toggle('active');
            })
        })
    }

    Accordions(el){
        !el.querySelector('.box') || el.querySelectorAll('.box').forEach(item => {
            item.querySelector('.title').addEventListener('click', () => {
                this.slideToggle(item.querySelector('.text'), 500);
            });
        })
    }

    SwiperGrup(el){
        new Swiper(el.querySelector(".mySwiper"), {
            slidesPerView: 2,
            spaceBetween: 0,
            navigation: {
                nextEl: el.querySelector(".swiper-button-next"),
                prevEl: el.querySelector(".swiper-button-prev"),
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                },
            }
        });
    }

    slideUp(target, duration = 500) {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout(() => {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            //alert("!");
        }, duration);
    }

    slideDown(target, duration = 500) {
        target.style.removeProperty('display');
        let display = window.getComputedStyle(target).display;

        if (display === 'none')
            display = 'block';

        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        window.setTimeout(() => {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
        }, duration);
    }

    slideToggle(target, duration = 500) {
        if (window.getComputedStyle(target).display === 'none') {
            return this.slideDown(target, duration);
        } else {
            return this.slideUp(target, duration);
        }
    }
}

export default Customer;

new Customer();